import React, { useState, useEffect, useCallback, useRef } from 'react';
import style from './MyDataDetails.module.css';
import CustomDatePicker from '../../../../components/datepicker/CustomDatePicker';
import ToastPopup from '../../../../components/comm/ToastPopup';
import { useNavigate } from 'react-router-dom';
import URL from '../../../../constants/url';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import Modal from '../../../../components/comm/Modal';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';


import '../../../../components/comm/LoadingModal.css';
import CircularProgress from '@mui/material/CircularProgress';

const PAGE_SIZE = 10;

const MyDataDetails = () => {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);

    const [pageInfo, setPageInfo] = useState({
        '1': { list: [], pageNo: 1, hasNext: true }, //전체
        '2': { list: [], pageNo: 1, hasNext: true }, //진료
        '3': { list: [], pageNo: 1, hasNext: true }, //처방
        '4': { list: [], pageNo: 1, hasNext: true }, //검사
    });

    const scrollRef = useRef(null);
    const scrollRef2 = useRef(null);
    const scrollRef3 = useRef(null);
    const scrollRef4 = useRef(null);

    const scrollRefMap = {
        '1': scrollRef,
        '2': scrollRef2,
        '3': scrollRef3,
        '4': scrollRef4,
    };

    const [isFetching, setIsFetching] = useState(false);

    //Tab
    const [value, setValue] = React.useState('1');
    // const [calledOnce, setCalledOnce] = useState(false);

    const [modalOpen, setModalOpen] = useState(false);  //시작일 > 종료일
    const [modalMessage, setModalMessage] = useState(''); //모달 메세지

    const closeModal = () => {
        setModalOpen(false);
        // 모달 닫힌 후 BottomSheet를 다시 열고 싶다면 조금 딜레이를 줌
        setTimeout(() => {
            setOpen(true);
        }, 100); // 100ms 정도면 애니메이션 뒤 열림
    }

    const [calledOnce, setCalledOnce] = useState({
        '1': false,
        '2': false,
        '3': false,
        '4': false,
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setPageInfo(prev => ({
            ...prev,
            [newValue]: {
                list: [],
                pageNo: 1,
                hasNext: true
            }
        }));
        setCalledOnce(prev => ({
            ...prev,
            [newValue]: false
        }));
    };

    //조회 기간
    const [displayPeriodText, setDisplayPeriodText] = useState('최근 1년');
    const [selectedPeriod, setSelectedPeriod] = useState('1year'); // '1year', '2year', '3year', 'custom'
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [datePickerType, setDatePickerType] = useState(null); // 'start' or 'end'

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const innerSheetRef = useRef(null); // 바텀시트 내부 ref
    const yearSheetRef = useRef(null); // 일자 조회 ref
    const startSheetRef = useRef(null); // 시작일 ref
    const endSheetRef = useRef(null); // 종료일 ref
    const modalContentRef = useRef(null);

    const [open, setOpen] = useState(false); // 조회 시트 열기
    const [daySelectOpen, setDaySelectOpen] = useState(false); // 날짜 선택 시트 열기
    const [selectInputValue, setSelectInputValue] = useState(false); // 라디오 버튼 input 값

    useEffect(() => {
        setOpen(false);
        setDaySelectOpen(false);
    }, []);

    function onDismiss() {
        setOpen(false);
    }

    const openDaySetting = (type) => {
        setDatePickerType(type);
        setOpen(false);
        setDaySelectOpen(true);
    };

    useEffect(() => {
        const today = new Date();
        const end = today;
        let start = new Date(today);

        if (selectedPeriod === '1year') {
            start.setFullYear(today.getFullYear() - 1);
        } else if (selectedPeriod === '2year') {
            start.setFullYear(today.getFullYear() - 2);
        } else if (selectedPeriod === '3year') {
            start.setFullYear(today.getFullYear() - 3);
        } else if (selectedPeriod === 'custom') {
            // If no dates set yet, default to 1 year ago / today or keep existing
            // if (!startDate || !endDate) {
            //     start = new Date(today);
            //     start.setFullYear(today.getFullYear() - 1);
            //     setStartDate(start);
            //     setEndDate(end);
            //     return;
            // } else {
            //     return; // keep existing custom dates
            // }
            return;
        }

        setStartDate(start);
        setEndDate(end);

        

    }, [selectedPeriod]);

    const formatDate = (date) => {
        if (!date) return '';
        const y = date.getFullYear();
        const m = (date.getMonth() + 1).toString().padStart(2, '0');
        const d = date.getDate().toString().padStart(2, '0');
        return `${y}.${m}.${d}`;
    };

    // CustomDatePicker에서 선택된 날짜를 받아서 startDate 또는 endDate 상태 변경
    const handleDateConfirm = (selectedDate) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // 시간 제거해서 날짜만 비교

        let showModal = false;

        // 시작일을 선택하는 경우, 종료일보다 클 수 없음
        // if (datePickerType === 'start' && endDate && selectedDate > endDate) {
        //     setToastMessage('시작일이 종료일 보다 클 수 없습니다.')
        //     setToast(true);
        //     setTimeout(() => setToast(false), 2000);
        //     return;
        // }

        // 종료일을 선택하는 경우, 시작일보다 작을 수 없음
        // if (datePickerType === 'end' && startDate && selectedDate < startDate) {
        //     setToastMessage('종료일이 시작일 보다 작을 수 없습니다.')
        //     setToast(true);
        //     setTimeout(() => setToast(false), 2000);
        //     return;
        // }

        if (datePickerType === 'start') {
            if (selectedDate > today) {
                setModalMessage('시작일을 종료일보다 과거 날짜로 선택해주세요.');
                showModal = true;
            } else if (endDate && selectedDate > endDate) {
                setModalMessage('시작일을 종료일보다 과거 날짜로 선택해주세요.');
                showModal = true;
            }

            setTimeout(() => {
                if (startSheetRef .current) {
                    startSheetRef .current.focus({ preventScroll: true });
                    startSheetRef .current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 200);

        } else if (datePickerType === 'end') {
            if (startDate && selectedDate < startDate) {
                setModalMessage('종료일은 시작일보다 미래 날짜로 선택해주세요.');
                showModal = true;
            }
            setTimeout(() => {
                if (endSheetRef .current) {
                    endSheetRef .current.focus({ preventScroll: true });
                    endSheetRef .current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 200);
        }

        if (showModal) {
            setOpen(false); // BottomSheet 완전히 닫기
            setModalOpen(true);
            return;
        }

        if (datePickerType === 'start') {
            setStartDate(selectedDate);
        } else if (datePickerType === 'end') {
            setEndDate(selectedDate);
        }

        setDaySelectOpen(false);
        setOpen(true); // 다시 기간 선택 BottomSheet 열기
    };

    const handleConfirm = () => {
        if (selectedPeriod === 'custom') {
            if (!startDate || !endDate) {
                // 시작일 또는 종료일 선택 안됨
                setModalMessage('시작일과 종료일을 선택해주세요.');
                setOpen(false);
                setModalOpen(true);
                return;
            }

            const diffTime = endDate.getTime() - startDate.getTime();
            const diffDays = diffTime / (1000 * 60 * 60 * 24);
            if (diffDays > (365 * 3) + 1 ) {
                // 3년 이상 차이
                setModalMessage('시작일을 종료일은 3년 이내로 설정해주세요.');
                setOpen(false);
                setModalOpen(true);
                return;
            }
        }
        
        if (selectedPeriod === '1year') {
            setDisplayPeriodText('최근 1년');
        } else if (selectedPeriod === '2year') {
            setDisplayPeriodText('최근 2년');
        } else if (selectedPeriod === '3year') {
            setDisplayPeriodText('최근 3년');
        } else if (selectedPeriod === 'custom') {
            setDisplayPeriodText(
                `${formatDate(startDate)} ~ ${formatDate(endDate)}`
            );
        }
        onDismiss();

        //여기서 조회
        retrieveDetailInfo(value, startDate, endDate, 1);

        setTimeout(() => {
            if (yearSheetRef .current) {
                yearSheetRef .current.focus({ preventScroll: true });
                yearSheetRef .current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 200);
    };


    const retrieveDetailInfo = useCallback(async (tabGbn, startDt, endDt, pageNo) => {

        if (isFetching) return; // 중복 방지
        setIsFetching(true);
    
        const url = "/mypage/retrieveDetailInfo";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
            noLoading : true
        }

        const formatStartDt = startDt.getFullYear().toString() +
            String(startDt.getMonth() + 1).padStart(2, '0') +
            String(startDt.getDate()).padStart(2, '0');

        const formatEndDt = endDt.getFullYear().toString() +
            String(endDt.getMonth() + 1).padStart(2, '0') +
            String(endDt.getDate()).padStart(2, '0');

        const params = {tabGbn : tabGbn , startDt : formatStartDt , endDt : formatEndDt, pageNo : pageNo, pageSize: PAGE_SIZE};
        
        setIsLoading(true);
        await axiosApi.post(url, params, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                if(tabGbn === '1') {
                    const hasNext = res.data.result.hasNext;
                    const newList = res.data.result.totalList;
                    setPageInfo(prev => {
                        const prevList = pageNo > 1 ? prev[tabGbn].list : [];
                        return {
                            ...prev,
                            [tabGbn]: {
                            list: [...prevList, ...newList],
                            pageNo,
                            hasNext: hasNext,
                            }
                        };
                    });

                } else if(tabGbn === '2') {
                    const hasNext = res.data.result.hasNext;
                    // setClnicList([...res.data.result.clnicList]);
                    const newList = res.data.result.clnicList;
                    setPageInfo(prev => {
                        const prevList = pageNo > 1 ? prev[tabGbn].list : [];
                        return {
                            ...prev,
                            [tabGbn]: {
                            list: [...prevList, ...newList],
                            pageNo,
                            hasNext: hasNext,
                            }
                        };
                    });

                } else if(tabGbn === '3') {
                    const hasNext = res.data.result.hasNext;
                    // setMedPrscList([...res.data.result.medPrscList]);
                    const newList = res.data.result.medPrscList;
                    setPageInfo(prev => {
                        const prevList = pageNo > 1 ? prev[tabGbn].list : [];
                        return {
                            ...prev,
                            [tabGbn]: {
                            list: [...prevList, ...newList],
                            pageNo,
                            hasNext: hasNext,
                            }
                        };
                    });
                } else if(tabGbn === '4') {
                    const hasNext = res.data.result.hasNext;
                    // setExamRsltList([...res.data.result.examRsltList]);
                    const newList = res.data.result.examRsltList;
                    setPageInfo(prev => {
                        const prevList = pageNo > 1 ? prev[tabGbn].list : [];
                        return {
                            ...prev,
                            [tabGbn]: {
                            list: [...prevList, ...newList],
                            pageNo,
                            hasNext: hasNext,
                            }
                        };
                    });
                } 
            } else {
                setPageInfo(prev => {
                const updated = { ...prev };
                Object.keys(updated).forEach(tab => {
                    updated[tab] = {
                        ...updated[tab],
                        hasNext: false
                    };
                });
                return updated;
            });
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            setPageInfo(prev => {
                const updated = { ...prev };
                Object.keys(updated).forEach(tab => {
                    updated[tab] = {
                        ...updated[tab],
                        hasNext: false
                    };
                });
                return updated;
            });
            console.error("상세정보 호출 중 오류  : ", err);
        }).finally(() => {
            setIsFetching(false);
            setIsLoading(false);
        });
    }, [isFetching]);

    useEffect(() => {
        if (startDate && endDate && !calledOnce[value]) {
            retrieveDetailInfo(value, startDate, endDate, 1);
            setCalledOnce(prev => ({
                ...prev,
                [value]: true
            }));
        }
    }, [value, startDate, endDate, retrieveDetailInfo, calledOnce]);

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            if (
                entries[0].isIntersecting &&
                pageInfo[value]?.hasNext &&
                !isFetching
            ) {
                setPageInfo(prev => ({
                    ...prev,
                    [value]: {
                        ...prev[value],
                        pageNo: prev[value].pageNo + 1
                    }
                }));
            }
        }, { threshold: 1.0 });

        const currentRef = scrollRefMap[value]?.current;
        if (currentRef) observer.observe(currentRef);

        return () => {
            if (currentRef) observer.unobserve(currentRef);
        };
    }, [value, pageInfo, isFetching]);

    useEffect(() => {
        const currPageInfo = pageInfo[value];
        if (
            startDate && endDate &&
            currPageInfo &&
            currPageInfo.pageNo > 1 &&
            currPageInfo.hasNext
        ) {
            retrieveDetailInfo(value, startDate, endDate, currPageInfo.pageNo);
        }
    }, [pageInfo[value]?.pageNo]);


    /** iOS 배경 스크롤 방지 */
    useEffect(() => {
        const isAnySheetOpen = open || daySelectOpen || modalOpen;
        if (isAnySheetOpen) {
        document.body.style.overflow = 'hidden';
        document.body.style.touchAction = 'none';
        } else {
        document.body.style.overflow = '';
        document.body.style.touchAction = '';
        }

        return () => {
        document.body.style.overflow = '';
        document.body.style.touchAction = '';
        };
    }, [open, daySelectOpen, modalOpen]);


    /**  딤드 클릭 이벤트 차단용 레이어 */
    const OverlayBlocker = () => {
        // 바텀시트가 열려 있을 때만 클릭 감지
        const handleClick = () => {
            if (open) setOpen(false);
            if (daySelectOpen) setDaySelectOpen(false);
        };

        return (
            <div
            className={`${style['bottomsheet-overlay-block']} ${
                open || daySelectOpen ? style['active'] : ''
            }`}
            onClick={handleClick} // 클릭 시 닫힘
            />
        );
    };

    // 모달 오픈 시 포커스 이동
    useEffect(() => {
        if (modalOpen && modalContentRef.current) {
            modalContentRef.current.focus({ preventScroll: true });
        }
    }, [modalOpen]);

    return (
        <>
            <div className={style['tab-content-box']}>
                <TabContext value={value}>
                    <div className="top-tab-head" data-type="b">
                        <TabList
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                            variant="scrollable"
                            scrollButtons={false}
                            className={style['tab-lists']}
                        >
                            <Tab label="전체" value="1" disableRipple />
                            <Tab label="진료" value="2" disableRipple />
                            <Tab label="처방" value="3" disableRipple />
                            <Tab label="검사" value="4" disableRipple />
                        </TabList>
                    </div>
                    <div className={style['top-select-box']}>
                        <button
                            className={style['select-day-btn']}
                            ref={yearSheetRef}
                            onClick={()=> {
                                setOpen(true)
                                setTimeout(() => {
                                    if (innerSheetRef.current) {
                                        innerSheetRef.current.focus({ preventScroll: true });
                                    }
                                });
                            }}
                        >
                            <span>{displayPeriodText}</span>
                        </button>
                    </div>

                    {/* 전체 */}
                    <TabPanel value="1">
                        <div className={style['tab-content']}>
                        {pageInfo['1'].list.length > 0 && 
                            pageInfo['1'].list.map((item, idx)=> {
                                return (
                                    <div key={'total_' + idx} className={style['content-box']}>
                                        <div className={style['top']}>
                                            <strong>{item.formatClnicDt}({item.clnicDayKor})</strong>
                                        </div>
                                        <div className={style['mid']}>
                                            <div className={style['tit-box']}>
                                                <p data-icon={item.oiesSeCd === 'O' || item.oiesSeCd === 'I' ? "1" : "2"}>{item.rate}진료</p>
                                                <button
                                                    className={style['more-btn']}
                                                    onClick={() =>
                                                        navigate(URL.HOSPITAL_MEDICALDETAILS, {
                                                            state: {
                                                                hsptlCd: item.hsptlCd,
                                                                hsptlNm: item.hsptlNm,
                                                                patntId: item.patntId,
                                                                deptCd: item.deptCd,
                                                                clnicDt: item.clnicDt,
                                                                rcptNo : item.rcptNo
                                                            }                                                                     
                                                        })
                                                    }
                                                >
                                                    <span>상세보기</span>
                                                </button>
                                            </div>
                                            <div className={style['span-group']}>
                                                <span>{item.hsptlNm}</span>
                                                <span>{item.deptNm}</span>
                                            </div>
                                            <p className={style['name']}>
                                                {item.doctrNm + ' ' + (item.nuHsptlJbpt ? item.nuHsptlJbpt : '') }님
                                            </p>
                                            <span className={style['date']}>
                                                {item.formatClnicDt}({item.clnicDayKor}) {item.clnicTimeKor}
                                            </span>
                                        </div>
                                        <div className={style['bottom']}>
                                            <ul>
                                                <li
                                                    onClick={() =>{
                                                        if(item.prscrptnTestCtgrCnt > 0) {
                                                            navigate(URL.INSPECTION_TOTAL_DETAIL, {
                                                                state: {
                                                                    hsptlCd: item.hsptlCd,
                                                                    patntId: item.patntId,
                                                                    deptCd: item.deptCd,
                                                                    treatYmd: item.clnicDt,
                                                                    rcptNo: item.examRcptNo,
                                                                }                                                                     
                                                            })
                                                        } else {
                                                            setToastMessage('검사 내역이 없습니다.');
                                                            setToast(true);
                                                        }
                                                    }}
                                                >
                                                    <div className={style['list-top']}>
                                                        <p>
                                                            검사 <span>{item.prscrptnTestCtgrCnt}</span> 건
                                                        </p>
                                                        <button
                                                            className={
                                                                style['more-btn']
                                                            }
                                                        >
                                                            <span className="blind">
                                                                더보기
                                                            </span>
                                                        </button>
                                                    </div>
                                                    <div className={style['lists']}>
                                                        <p>{item.prscrptnTestCtgrCnt > 0 ? item.prscrptnTestCtgrNmArr : '검사 내역이 없습니다.'}</p>
                                                    </div>
                                                </li>
                                                <li
                                                    onClick={() =>{
                                                        if(item.prscrptnCnt > 0) {
                                                            navigate(URL.HOSPITAL_PRESCRIPTIONDETAIL, {
                                                                state: {
                                                                    hsptlCd: item.hsptlCd,
                                                                    patntId: item.patntId,
                                                                    deptCd: item.deptCd,
                                                                    treatYmd: item.clnicDt,
                                                                }                                                                     
                                                            })
                                                        } else {
                                                            setToastMessage('처방 내역이 없습니다.');
                                                            setToast(true);
                                                        }
                                                    }}
                                                >
                                                    <div className={style['list-top']}>
                                                        <p>
                                                            처방 <span>{item.prscrptnCnt}</span> 건
                                                        </p>
                                                        <button
                                                            className={
                                                                style['more-btn']
                                                            }
                                                        >
                                                            <span className="blind">
                                                                더보기
                                                            </span>
                                                        </button>
                                                    </div>
                                                    <div className={style['lists']}>
                                                        <p>{item.prscrptnCnt > 0 ? item.prscrptnNms : '처방 내역이 없습니다.'}</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        </div>

                        <div ref={scrollRefMap['1']} style={{ height: 1 }}></div>
                        {pageInfo['1'].list.length <= 0 && 
                            <div className={style['tab-content']}>
                                <div className={style['no-content-box']}>
                                    <p>내역이 없습니다.</p>
                                </div>
                            </div>
                        }

                    </TabPanel>

                    {/* 진료 */}
                    <TabPanel value="2">
                        {/* {clnicList.length > 0 && 
                            clnicList.map((item, idx)=> { */}
                        {pageInfo['2'].list.length > 0 && 
                            pageInfo['2'].list.map((item, idx)=> {
                                return (
                                    <div key={'clnic_' + idx} className={style['tab-content']}>
                                        <div className={style['content-box']}>
                                            <div className={style['top']}>
                                                <strong>{item.formatClnicDt}({item.clnicDayKor})</strong>
                                            </div>
                                            <div className={style['mid']}>
                                                <div className={style['tit-box']}>
                                                    <p data-icon={item.oiesSeCd === 'O' || item.oiesSeCd === 'I' ? "1" : "2"}>{item.rate}진료</p>
                                                    <button
                                                        className={style['more-btn']}
                                                        onClick={() =>
                                                            navigate(URL.HOSPITAL_MEDICALDETAILS, {
                                                                state: {
                                                                    hsptlCd: item.hsptlCd,
                                                                    hsptlNm: item.hsptlNm,
                                                                    patntId: item.patntId,
                                                                    deptCd: item.deptCd,
                                                                    clnicDt: item.clnicDt,
                                                                    rcptNo : item.rcptNo
                                                                }                                                                     
                                                            })
                                                        }
                                                    >
                                                        {' '}
                                                        <span>상세보기</span>
                                                    </button>
                                                </div>
                                                <div className={style['span-group']}>
                                                    <span>{item.hsptlNm}</span>
                                                    <span>{item.deptNm}</span>
                                                </div>
                                                <p className={style['name']}>
                                                    {item.doctrNm + ' ' + (item.nuHsptlJbpt ? item.nuHsptlJbpt : '') }님
                                                </p>
                                                <span className={style['date']}>
                                                    {item.formatClnicDt}({item.clnicDayKor}) {item.clnicTimeKor}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div ref={scrollRefMap['2']} style={{ height: 1 }}></div>
                        {pageInfo['2'].list.length <= 0 && 
                            <div className={style['tab-content']}>
                                <div className={style['no-content-box']}>
                                    <p>내역이 없습니다.</p>
                                </div>
                            </div>
                        }
                        
                    </TabPanel>

                    {/* 처방 */}
                    <TabPanel value="3">
                        {/* {medPrscList.length > 0 && 
                            medPrscList.map((item, idx)=> { */}
                        {pageInfo['3'].list.length > 0 && 
                            pageInfo['3'].list.map((item, idx)=> {
                                return (
                                    <div key={'mdePrsc_' + idx} className={style['tab-content']}>
                                        <div className={style['content-box']}>
                                            <div className={style['top']}>
                                                {/* <strong>{item.formatPrscrptnDt}({item.prscrptnDayKor})</strong> */}
                                                <strong>{item.formatTreatYmd}({item.treatYmdKor})</strong>
                                            </div>
                                            <div className={style['mid']} >
                                                <div className={style['tit-box']} data-m-b='sm'>
                                                    <p className={style['round-box']}>처방 <span>{item.prscrptnCnt}</span>건</p>
                                                    <button
                                                        className={style['more-btn']}
                                                        onClick={() =>
                                                            navigate(URL.HOSPITAL_PRESCRIPTIONDETAIL, {
                                                                state: {
                                                                    hsptlCd: item.hsptlCd,
                                                                    patntId: item.patntId,
                                                                    deptCd: item.deptCd,
                                                                    treatYmd: item.treatYmd
                                                                }                                                                     
                                                            })
                                                        }
                                                    >
                                                        <span>상세보기</span>
                                                    </button>
                                                </div>
                                                <div className={style['span-group']}>
                                                    <span>{item.hsptlNm}</span>
                                                    <span>{item.deptNm}</span>
                                                </div>
                                                <p className={style['name']}>
                                                    {item.doctrNm + ' ' + (item.nuHsptlJbpt ? item.nuHsptlJbpt : '') }님
                                                </p>
                                                <span className={style['date']}>
                                                    {/* {item.formatPrscrptnDt}({item.prscrptnDayKor}) */}
                                                    {item.formatTreatYmd}({item.treatYmdKor})
                                                </span>
                                                <span className={style['medic-name']}>
                                                    {item.prscrptnNms}
                                                </span>
                                            </div>
                                            {/* <div className={style['bottom']}>
                                                <ul>
                                                    <li
                                                        onClick={() =>
                                                            navigate(URL.HOSPITAL_PRESCRIPTIONDETAIL, {
                                                                state: {
                                                                    hsptlCd: item.hsptlCd,
                                                                    patntId: item.patntId,
                                                                    deptCd: item.deptCd,
                                                                    treatYmd: item.treatYmd
                                                                }                                                                     
                                                            })
                                                        }
                                                    >
                                                        <div className={style['list-top']}>
                                                            <p>
                                                                처방 <span>{item.prscrptnCnt}</span> 건
                                                            </p>
                                                            <button
                                                                className={
                                                                    style['more-btn']
                                                                }
                                                            >
                                                                <span className="blind">
                                                                    더보기
                                                                </span>
                                                            </button>
                                                        </div>
                                                        <div className={style['lists']}>
                                                            <p>
                                                                {item.prscrptnNms}
                                                            </p>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div> */}
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div ref={scrollRefMap['3']} style={{ height: 1 }}></div>
                        {pageInfo['3'].list.length <= 0 && 
                            <div className={style['tab-content']}>
                                <div className={style['no-content-box']}>
                                    <p>내역이 없습니다.</p>
                                </div>
                            </div>
                        }
                        
                    </TabPanel>

                    {/* 검사 */}
                    <TabPanel value="4">
                        {/* {examRsltList.length > 0 && 
                            examRsltList.map((item, idx)=> { */}
                        {pageInfo['4'].list.length > 0 && 
                            pageInfo['4'].list.map((item, idx)=> {
                                return (
                                    <div key={'mdePrsc_' + idx} className={style['tab-content']}>
                                        <div className={style['content-box']}>
                                            <div className={style['top']}>
                                                {/* <strong>{item.prscrptnTestRsltDt}({item.prscrptnTestRsltDay})</strong> */}
                                                <strong>{item.formatTestDt}({item.testDtDay})</strong>
                                            </div>
                                            <div className={style['mid']}>
                                                <div className={style['tit-box']} data-m-b='sm'>
                                                    <p className={style['round-box']}>검사 <span>{item.prscrptnTestCtgrCnt}</span>건</p>
                                                    <button
                                                        className={style['more-btn']}
                                                        onClick={() =>
                                                        navigate(URL.HOSPITAL_INSPECTIONDETAIL, {
                                                            state: {
                                                                hsptlCd: item.hsptlCd,
                                                                patntId: item.patntId,
                                                                deptCd: item.deptCd,
                                                                testDt: item.testDt
                                                            }                                                                     
                                                        })
                                                    }
                                                    >
                                                        <span>상세보기</span>
                                                    </button>
                                                </div>
                                                <div className={style['span-group']}>
                                                    <span>{item.hsptlNm}</span>
                                                    <span>{item.deptNm}</span>
                                                </div>
                                                <p className={style['name']}>
                                                    {item.doctrNm + ' ' + (item.nuHsptlJbpt ? item.nuHsptlJbpt : '') }님
                                                </p>
                                                <span className={style['date']}>
                                                    {/* {item.prscrptnTestRsltDt}({item.prscrptnTestRsltDay}) */}
                                                    {item.formatTestDt}({item.testDtDay})
                                                </span>
                                                <span className={style['medic-name']}>
                                                    {item.prscrptnTestCtgrNmArr}
                                                </span>
                                            </div>
                                            {/* <div className={style['bottom']}>
                                                <ul>
                                                    <li
                                                        onClick={() =>
                                                            navigate(URL.HOSPITAL_INSPECTIONDETAIL, {
                                                                state: {
                                                                    hsptlCd: item.hsptlCd,
                                                                    patntId: item.patntId,
                                                                    deptCd: item.deptCd,
                                                                    testDt: item.testDt
                                                                }                                                                     
                                                            })
                                                        }
                                                    >
                                                        <div className={style['list-top']}>
                                                            <p>
                                                                검사 <span>{item.prscrptnTestCtgrCnt}</span> 건
                                                            </p>
                                                            
                                                            <button
                                                                className={
                                                                    style['more-btn']
                                                                }
                                                            >
                                                                <span className="blind">
                                                                    더보기
                                                                </span>
                                                            </button>
                                                        </div>
                                                        <div className={style['lists']}>
                                                            <p>
                                                                {item.prscrptnTestCtgrNmArr}
                                                            </p>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div> */}
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div ref={scrollRefMap['4']} style={{ height: 1 }} ></div>
                        {pageInfo['4'].list.length <= 0 && 
                            <div className={style['tab-content']}>
                                <div className={style['no-content-box']}>
                                    <p>내역이 없습니다.</p>
                                </div>
                            </div>
                        }
                        
                    </TabPanel>
                </TabContext>

                {!modalOpen && ( 
                    <BottomSheet

                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지

                        open={open}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking
                    >
                        <div className={style['content-wrap']}>
                            <div className={style['inner-box']} ref={innerSheetRef} tabIndex={0}>
                                <div className={style['select-period-box']}>
                                    <strong>조회 기간</strong>
                                    <ul>
                                        <li>
                                            <div
                                                className="radio-selectbox"
                                                data-style="b"
                                                aria-pressed={selectedPeriod === '1year'}
                                                aria-label={selectedPeriod === '1year' ? '1년 선택됨' : '1년 선택하기'}
                                                tabIndex={-1}
                                            >
                                                <input
                                                    type="radio"
                                                    id="year1"
                                                    name="year-select"
                                                    value="1year"
                                                    checked={
                                                        selectedPeriod === '1year'
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedPeriod(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                                <label htmlFor="year1" aria-hidden={true}>
                                                    <span>1년</span>
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div
                                                className="radio-selectbox"
                                                data-style="b"
                                                aria-pressed={selectedPeriod === '2year'}
                                                aria-label={selectedPeriod === '2year' ? '2년 선택됨' : '2년 선택하기'}
                                                tabIndex={-1}
                                            >
                                                <input
                                                    type="radio"
                                                    id="year2"
                                                    name="year-select"
                                                    value="2year"
                                                    checked={
                                                        selectedPeriod === '2year'
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedPeriod(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                                <label htmlFor="year2" aria-hidden={true} >
                                                    <span>2년</span>
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div
                                                className="radio-selectbox"
                                                data-style="b"
                                                aria-pressed={selectedPeriod === '3year'}
                                                aria-label={selectedPeriod === '3year' ? '3년 선택됨' : '3년 선택하기'}
                                                tabIndex={-1}
                                            >
                                                <input
                                                    type="radio"
                                                    id="year3"
                                                    name="year-select"
                                                    value="3year"
                                                    checked={
                                                        selectedPeriod === '3year'
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedPeriod(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                                <label htmlFor="year3" aria-hidden={true}>
                                                    <span>3년</span>
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div
                                                className="radio-selectbox"
                                                data-style="b"
                                                aria-pressed={selectedPeriod === 'custom'}
                                                aria-label={selectedPeriod === 'custom' ? '직접입력 선택됨' : '직접입력 선택하기'}
                                                tabIndex={-1}
                                            >
                                                <input
                                                    type="radio"
                                                    id="custom"
                                                    name="year-select"
                                                    value="custom"
                                                    checked={
                                                        selectedPeriod === 'custom'
                                                    }
                                                    onChange={(e) =>{
                                                        setSelectedPeriod(e.target.value);
                                                        setStartDate(null); // placeholder 보이게 초기화
                                                        setEndDate(null);   // placeholder 보이게 초기화
                                                    }}
                                                />
                                                <label htmlFor="custom" aria-hidden={true}>
                                                    <span>직접입력</span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div className={style['select-day-box']}>
                                    <strong>시작일</strong>
                                    <div className="input-box" data-type="d" ref={startSheetRef} tabIndex={1}>
                                        {selectInputValue ? (
                                            <input
                                                type="button"
                                                inputmode="none"
                                                id="pill-name"
                                                placeholder="시작일 선택"
                                                value=""
                                                onClick={() => openDaySetting()}
                                            />
                                        ) : (
                                            <input
                                                type="button"
                                                inputMode="none"
                                                //value={formatDate(startDate)}
                                                value={startDate ? formatDate(startDate) : ""}
                                                placeholder="시작일 선택"
                                                readOnly
                                                className={`${style['no-select']} ${!startDate ? style['placeholder-active'] : ''}`}
                                                onFocus={(e) => e.target.blur()}
                                                disabled={
                                                    selectedPeriod !== 'custom'
                                                }
                                                onClick={() => {
                                                    if (selectedPeriod === 'custom')
                                                        openDaySetting('start');
                                                }}
                                            />
                                        )}
                                        <span className={style['placeholder-box']}>시작일 선택</span>
                                    </div>
                                </div>

                                <div className={style['select-day-box']}>
                                    <strong>종료일</strong>
                                    <div className="input-box" data-type="d" ref={endSheetRef} tabIndex={0}>
                                        {selectInputValue ? (
                                            <input
                                                type="button"
                                                inputmode="none"
                                                id="pill-name"
                                                placeholder="종료일 선택"
                                                value=""
                                                onClick={() => openDaySetting()}
                                            />
                                        ) : (
                                            <input
                                                type="button"
                                                inputMode="none"
                                                //value={formatDate(endDate)}
                                                value={endDate ? formatDate(endDate) : ""}
                                                placeholder="종료일 선택"
                                                readOnly
                                                className={`${!endDate ? style['placeholder-active'] : ''}`}
                                                disabled={
                                                    selectedPeriod !== 'custom'
                                                }
                                                onClick={() => {
                                                    if (selectedPeriod === 'custom')
                                                        openDaySetting('end');
                                                }}
                                            />
                                        )}
                                        <span className={style['placeholder-box']}>종료일 선택</span>
                                    </div>
                                </div>

                                <div className={style['bottom-box']}>
                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        onClick={handleConfirm}
                                    >
                                        <span>확인</span>
                                    </button>
                                </div>

                                <button className={style["close-btn"]} 
                                    onClick={()=> {
                                        onDismiss();
                                        setTimeout(() => {
                                            if (yearSheetRef .current) {
                                                yearSheetRef .current.focus({ preventScroll: true });
                                                yearSheetRef .current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                            }
                                        }, 200);
                                    }}
                                >
                                    <span className="blind">팝업 닫기</span>
                                </button>
                            </div>
                        </div>
                    </BottomSheet>
                )}
                <BottomSheet

                    scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                    expandOnContentDrag={false} // 내용 드래그로 확장 방지

                    open={daySelectOpen}
                    onDismiss={() => setDaySelectOpen(false)}
                    snapPoints={({ minHeight }) => minHeight}
                    blocking
                >
                        <CustomDatePicker
                            type={datePickerType}
                            titleTxt={datePickerType === 'start' ? '시작일 선택' : '종료일 선택'}
                            onClose={() => {
                                setDaySelectOpen(false);
                                setOpen(true);

                                setTimeout(() => {
                                // datePickerType이 start이면 startSheetRef, 아니면 endSheetRef로 포커스 복귀
                                const targetRef =
                                    datePickerType === 'start' ? startSheetRef : endSheetRef;

                                if (targetRef?.current) {
                                    targetRef.current.focus({ preventScroll: true });
                                    targetRef.current.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                    });
                                }
                                }, 200);
                            }}
                            onConfirm={handleDateConfirm}
                        />
                </BottomSheet>

                {/* 딤드 클릭 차단용 레이어 */}
                <OverlayBlocker />

                <Modal isOpen={modalOpen} setIsOpen={setModalOpen} ref={modalContentRef} tabIndex={-1}>
                    <div className='modal-box' data-type="a">
                        <div className='modal-top-box'>
                            <div className='title-box'>
                                <p>{modalMessage}</p>
                            </div>
                        </div>

                        <div className="modal-bottom-box"> 
                            <div className='btn-layout'>
                                <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={closeModal}>
                                    <span>확인</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                {toast && (
                    <ToastPopup
                        setToast={setToast}
                        message={toastMessage}
                        position="center"
                        opacity="90"
                    />
                )}
            </div>
            {isLoading && 
                <div className="loading-modal-backdrop">
                    <div>
                        <CircularProgress size="5rem"/>
                        <div className="loading-message">{"로딩 중입니다..."}</div>
                    </div>
                </div>
            }
        </>
    );
};

export default MyDataDetails;
